export var KeyCodes = {
  To: 32,
  yo: 9,
  _o: 13,
  _h: 27
};